import React, { Component } from 'react'
import Space from 'ui/Space'
import Link from 'ui/Link'
import { Display4 } from 'ui/typography'
import SubNavigation from 'ui/SubNavigation'
import { FlexGrid, FlexItem } from 'ui/flexgrid'
import ActivitySearch from './ActivitySearch'
import ActivityTable from './ActivityTable'
import ActivityFilter from './ActivityFilter'
import css from './Activity.module.css'

class ActivityHome extends Component {
  render () {
    return (
      <div>
        <SubNavigation title='Activity' />
        <div className={css.body}>
          <FlexGrid>
            <FlexItem width={250} spaceRight={28}>
              <ActivitySearch onSearch={this.props.setActivitySearchTerm} searchTerm={this.props.searchTerm} />
              <Space value={7} />
              <ActivityFilter onSelectFilter={this.props.setActivityFilter} selectedFilter={this.props.selectedFilter} />
              <Space value={28} />
              <Display4>What is this?</Display4>
              <Space value={4} />
              <p>A chronological history of the activity and changes made in your workspace over the past month.</p>
              <Space value={28} />
              <Display4>Email Notifications</Display4>
              <Space value={4} />
              <p>Set who should receive email notifications for activity within this workspace.</p>
              <Space value={7} />
              <Link href={this.props.notificationsLink} icon='rightArrow' rel='external'>
                Notification Settings
              </Link>
            </FlexItem>
            <FlexItem flex={1}>
              <ActivityTable
                heading='Last 30 days'
                didReceiveActivity={this.props.didReceiveActivity}
                hasActivity={this.props.hasActivity}
                didRequestFail={this.props.didRequestFail}
                items={this.props.activity}
                isLoading={this.props.isRequesting} />
            </FlexItem>
          </FlexGrid>
        </div>
      </div>
    )
  }

  componentDidMount () {
    this.props.fetchActivity()
  }
}

ActivityHome.displayName = 'ActivityHome'

export default ActivityHome



// WEBPACK FOOTER //
// ./components/Activity.js